"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChartStaticError = exports.ChartInteractionError = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _shared = require("@cian/peperrors/shared");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/** Этот пример взят из доки peperrors */
/* istanbul ignore next */
class ChartInteractionError extends _shared.GenericError {
  constructor(configuration) {
    super(_objectSpread(_objectSpread({}, configuration), {}, {
      type: 'ChartInteractionError'
    }));

    // Необходимо из-за особенности реализации наследования в TS. Иначе не будет работать instanceof BadRequestError
    Object.setPrototypeOf(this, ChartInteractionError.prototype);

    // Данный код не является обязательным, он нужен для того, чтобы не было лишнего слоя в стэктрейсе
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ChartInteractionError);
    } else {
      this.stack = new Error().stack;
    }
  }
}

/* istanbul ignore next */
exports.ChartInteractionError = ChartInteractionError;
class ChartStaticError extends _shared.GenericError {
  constructor(configuration) {
    super(_objectSpread(_objectSpread({}, configuration), {}, {
      type: 'ChartStaticError'
    }));

    // Необходимо из-за особенности реализации наследования в TS. Иначе не будет работать instanceof BadRequestError
    Object.setPrototypeOf(this, ChartStaticError.prototype);

    // Данный код не является обязательным, он нужен для того, чтобы не было лишнего слоя в стэктрейсе
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ChartStaticError);
    } else {
      this.stack = new Error().stack;
    }
  }
}
exports.ChartStaticError = ChartStaticError;